<!-- cases -->
  <div class="top-cases mb-2" *ngIf="suggestionData?.length>0">
    <div class="pl-3 pr-3 pt-2 pb-2 border-bottom">
      <div class="row">
        <div class="col-12">
          <p class="heading-4 mb-3">{{suggestionData?.text_highlight}}</p>
        </div>
      </div>
    </div>
    <div class="pl-2 pr-2">
      <!-- cases list -->
      <!-- item -->
      <div class="py-2 clearfix custom-owl-carousel bg-transparent px-0 shadow-none">
        <owl-carousel-o [options]="casesOptions">
          <ng-template carouselSlide>
            <div class="position-relative bg-grey-400 rounded cursor-pointer"
              (click)="dss?.show_feed_post_modal.next(1)">
              <div class="w-100 text-center">
                <svg data-name="Layer 1" id="Layer_1" viewBox="0 0 24 24" width="30px">
                  <defs>
                    <style>
                      .post-top-icon-1 {
                        fill: var(--white-color);
                      }
                    </style>
                  </defs>
                  <path class="post-top-icon-1"
                    d="M15.7,22.15H12.11V18.57l6.36-6.37V7.63L11.92,1.08H3.18A2.18,2.18,0,0,0,1,3.26V20.74a2.18,2.18,0,0,0,2.17,2.18H16.29a2.19,2.19,0,0,0,2.18-2.18V19.37ZM10.83,2.72l6,6h-6ZM5.37,10.91H14.1v2.18H5.37Zm5.46,6.55H5.37V15.28h5.46Z">
                  </path>
                  <path class="post-top-icon-1"
                    d="M13.2,19v2h2l6-6-2-2Zm9.64-5.56a.55.55,0,0,0,0-.77l-1.27-1.27a.55.55,0,0,0-.77,0l-1,1,2,2Z">
                  </path>
                </svg>
                <p class="text-white secondary-paragraph mt-2">Post A Case</p>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide *ngFor="let sugg of suggestionData?.products">
            <div (click)="fcs.getSuggestionDetail(sugg?.target)" class="cursor-pointer">
              <div class="position-relative rounded overflow-hidden">
                <div class="top-cases-overlay position-absolute w-100 h-100 pl-2 pr-2 pb-3 pt-2">
                  <div class="d-table h-100 top-cases-fixed">
                    <div class="d-table-cell align-bottom">
                      <p class="text-white primary-small">
                        {{sugg?.description | slice:0:40}}
                        {{(sugg?.description.length>40)? '...':''}}
                      </p>
                    </div>
                  </div>

                </div>
                <img class="rounded post-pic top-cases-box"
                  [src]="(sugg?.media?.media_type=='image')? sugg?.media?.media_url:sugg?.media?.media_thumbnail"
                  onerror="this.src='assets/images/grandround/image_placeholder.svg'" height="122"/>
              </div>
              <div class="mt-1 mb-1">
                <div>
                  <p class="secondary-paragraph text-truncate">{{sugg?.heading}}</p>
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
      </div>
      <!-- end cases list -->
    </div>
  </div>
  <!-- end cases -->